




























































































import firebase, { firestore, functions } from "firebase";
import { Component, Prop, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import PersonalAdd from "./PersonalAdd.vue"
import { ItemDocument } from '../struct/psdocument';
import * as D from '../struct/personal';
import { sprintf } from 'sprintf-js';
import moment from "moment"

const Visibilities = ["All", "Not Resolved", "Resolved"] as const;
type Visibility = typeof Visibilities[number];
const Sortings = ["createdTime", "updatedTime", "deadlineTime"] as const;
type Sorting = typeof Sortings[number];

type ItemPart<T> = {
  name?: string
  items: T[]
}

@Component({
  components: { PersonalAdd, },
})
export default class pshome extends Vue {
  private show_add = false
  private show_edit = false
  private unsubscriber?: () => void
  private docs: D.TaskItem[] = []
  private working_item: any = {}

  get working_create() {
    return !!this.working_item.new
  }

  private targetItem: any = null
  private itemEdited: any = null

  private visibility: Visibility = "Not Resolved"
  get resolveVisibility() {
    return Visibilities.map(title => ({ title }))
  }
  private show_sorting = false
  private sorting: Sorting = "createdTime"
  get sortings() {
    return Sortings.map(title => ({ title }))
  }

  get filtered_items() {
    switch (this.visibility) {
    case "Resolved": return this.docs.filter(item => item.resolved);
    case "Not Resolved": return this.docs.filter(item => !item.resolved);
    default: return this.docs;
    }
  }
  get sorted_items() {
    switch (this.sorting) {
    case "updatedTime":
      return _(this.filtered_items).sortBy(item => -item.updatedTime.getTime()).value();
    case "deadlineTime":
      return _(this.filtered_items).sortBy(item => -item.createdTime.getTime()).sortBy(item => item.deadlineTime ? -item.deadlineTime.getTime() : 0).value();
    default:
      return this.filtered_items;
    }
  }

  get pinned_items() {
    return this.sorting === "deadlineTime" ? this.sorted_items : _.sortBy(this.sorted_items, item => item.pinned ? 0 : 1);
  }

  get parted_items(): ItemPart<D.TaskItem>[] {
    if (this.sorting !== "deadlineTime") { return [{ items: this.pinned_items }]; }
    const parts: ItemPart<D.TaskItem>[] = []
    let sign: string = ""
    let part: ItemPart<D.TaskItem> | null =  null;
    this.pinned_items.forEach(item => {
      const t = item.deadlineTime;
      const nsign = t ? moment(t).format("YYYY-MM-DD") : "期限なし";
      if (sign !== nsign) {
        if (part && part.items.length > 0) {
          parts.push(part);
        }
        sign = nsign;
        part = { name: sign, items: [] }
      }
      part!.items.push(item)
    });
    if (part && part!.items.length > 0) {
      parts.push(part);
    }
    return parts;
  }

  async subscribe() {
    this.unsubscriber = ItemDocument.subscribe((change) => {
      const item = ItemDocument.deserialize<"Task">(change.doc);
      const doc = change.doc
      if (change.oldIndex >= 0) {
        this.docs.splice(change.oldIndex, 1);
      }
      if (change.newIndex >= 0) {
        this.docs.splice(change.newIndex, 0, item);
      }
    });
  }

  timeout(time: Date | undefined) {
    if (time) {
      return moment(time).format("YYYY-MM-DD HH:mm")
    } else {
      return "-"
    }
  }

  out(value: any) {
    console.log(value)
  }

  async pin(item: D.Item, pinned: boolean) {
    if (this.working_item[item.id]) { return }
    this.$set(this.working_item, item.id, true);
    try {
      await ItemDocument.pin(item, pinned);
    } catch(e) {
      console.error(e);
    }
    this.$delete(this.working_item, item.id);
  }

  async resolve(item: D.Item, resolve: boolean) {
    if (this.working_item[item.id]) { return }
    this.$set(this.working_item, item.id, true);
    try {
      await ItemDocument.resolve(item, resolve);
    } catch(e) {
      console.error(e);
    }
    this.$delete(this.working_item, item.id);
  }

  show_create() {
    this.targetItem = ItemDocument.skeltonTask()
    this.show_add = true
  }
  async createItem() {
    if (!this.itemEdited || this.working_item.new) { return }
    this.$set(this.working_item, "new", true);
    try {
      await ItemDocument.create({
        category: "Task",
        ...this.itemEdited,
      })
      this.show_add = false
    } catch (e) {
      console.error(e)
    }
    this.$delete(this.working_item, "new");
  }

  async updateItem() {
    if (!this.itemEdited || !this.targetItem || !this.targetItem.id || this.working_item[this.itemEdited.id]) { return }
    this.$set(this.working_item, this.targetItem.id, true);
    try {
      await ItemDocument.update({
        ..._.pick(this.targetItem, "id", "category"),
        ...this.itemEdited,
      })
      this.show_edit = false
    } catch (e) {
      console.error(e)
    }
    this.$delete(this.working_item, this.targetItem.id);
  }

  beforeCreate() {
  }

  created() {
  }

  mounted() {
    this.subscribe()
  }

  beforeDestroy() {
  }
}
